const Instance = {
  schema: {
    geometry: { label: 'Mesh', plug: 'PolyMesh', type: 'Plug' },
  },

  update: function (operator, primitive) {
    primitive.mesh = operator.geometry && operator.geometry.mesh;
  },
};

export default Instance;



// WEBPACK FOOTER //
// ./src/operators/PolyMesh/Instance.js